const workerScript = 'https://worker-cdn.kattana.io/v0.1.4/trades-bundle.js';

function getWorkerURL(url: string) {
  const content = `importScripts( "${url}" );`;
  return URL.createObjectURL(new Blob([content], { type: 'text/javascript' }));
}

const tradesWorker = () => {
  const worker_url = getWorkerURL(workerScript);

  const worker = new Worker(worker_url);

  return worker;
};

export { tradesWorker };
